module.exports = __webpack_public_path__ + "static/media/members.5fdd17d0.png";